import * as React from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Box": Box, "@mui/material/Collapse": Collapse, "@mui/material/IconButton": IconButton, "@mui/material/Table": Table, "@mui/material/TableBody": TableBody, "@mui/material/TableCell": TableCell, "@mui/material/TableContainer": TableContainer, "@mui/material/TableHead": TableHead, "@mui/material/TableRow": TableRow, "@mui/material/Typography": Typography, "@mui/material/Paper": Paper, "@mui/icons-material/KeyboardArrowDown": KeyboardArrowDownIcon, "@mui/icons-material/KeyboardArrowUp": KeyboardArrowUpIcon } } });
export default ClientProvider;
